import React, { useState, useRef } from 'react';
import ReactSVG from 'react-svg';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import SmartPortal from '../SmartPortal';
import Loader from "components/Loader";
import './styles.scss';

const CommentFile = ({ file, t, deleteFile, removable }) => {
  const [isFileDropdownOpen, setIsFileDropdownOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const elementRef = useRef(null);

  const handleDelete = () => {
    setIsDeleting(true); // Start spinner
    deleteFile(file.id, () => {setIsDeleting(false); setIsFileDropdownOpen(false)}); // Pass callback to stop spinner
  };

  const toggleFileActionsDropdown = () => {
    setIsFileDropdownOpen(prevState => !prevState);
  };

  function formatFileSize(sizeInBytes) {
    if (sizeInBytes === 0) return '(0 B)';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    const size = sizeInBytes / Math.pow(1024, i);
    return `(${size.toFixed(1).replace('.', ',')} ${units[i]})`;
  }

  return (
    <div className="comment-item__file">
      <a className="comment-item__file-link" target="_blank" href={`../mw/file?fileId=${file.id}&download=0`} title={file.name}>
        <ReactSVG className="comment-item__file-icon" src="/data/svg/comments_file.svg" />
        <div className="comment-item__file-name">{file.name}</div>
        <div className="comment-item__file-size">
          {file.file_size != null ? formatFileSize(file.file_size) : ''}
        </div>
      </a>
        <div className="comment-item__file-actions">
          <button
            type="button"
            className={cx("comment-item__file-dropdown-button", {"comment-item__file-dropdown-button--open": isFileDropdownOpen})}
            onClick={toggleFileActionsDropdown}
            aria-haspopup="true"
            aria-expanded={isFileDropdownOpen}
            aria-label="File Actions"
            ref={elementRef}
          >
            <ReactSVG className="comment-item__file-dropdown-icon" src="/data/svg/dropdown.svg" />
          </button>
          {isFileDropdownOpen && (
            <SmartPortal
              portalClassName="portal-comment-item__file"
              targetElement={elementRef && elementRef.current}
              portalPlacement="bottom inner-right"
              portalKey={file.id}
              onClickOutside={() => setIsFileDropdownOpen(false)}
              outerOffset={4}
            >
            <div className="comment-item__file-dropdown" role="menu">
              <a className="comment-item__file-dropdown__option" target="_blank" href={`../mw/file?fileId=${file.id}&download=1`} onClick={toggleFileActionsDropdown}>
                {t('commentSection.download')}
              </a>
              <a className="comment-item__file-dropdown__option" target="_blank" href={`../mw/file?fileId=${file.id}&download=0`} onClick={toggleFileActionsDropdown}>
                {t('commentSection.open')}
              </a>
              {removable && (
                <>
                  <div className="comment-item__file-dropdown__option"
                      // onClick={() => {
                        //     deleteFile(file.id);
                        //     setTimeout(() => setIsFileDropdownOpen(false), 250);
                        //   }
                        // }
                        onClick={handleDelete}
                  >
                    {t('commentSection.delete')}
                  </div>
                  {isDeleting && <Loader />}
                </>
              )}
            </div>
          </SmartPortal>
          )}
        </div>
    </div>
  );
};

export default (withTranslation()(CommentFile));
